import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { noMoney } from "../../imports";
import { useNavigation } from "@react-navigation/native";

export default function NoMoneyModal({ visible }) {
  const modal = useSelector((store) => store.modal);
  const navigation = useNavigation();
  return (
    <MyModal isVisible={modal.noMoney}>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Image
          resizeMode="contain"
          source={noMoney}
          style={{ width: "90%", marginBottom: 10, height: 220 }}
        />
        <View style={{ width: "90%", marginBottom: 10 }}>
          <MyText style={{ textAlign: "center" }}>
            {translate("no money #full text")}
          </MyText>
        </View>
        <View style={{ marginBottom: 10 }}>
          <MyButton
            text={translate("charge wallet")}
            onPress={() => navigation.navigate("Wallet", { mode: "charge" })}
          />
        </View>
      </View>
    </MyModal>
  );
}
